<script>

    import { MerchandiseStore } from '../stores'

    import Modal from '../$components/modal.svelte'

    import Merchandises from '../merchandises/merchandises.svelte'
    import MerchandiseRead from '../merchandises/merchandise.svelte'
    import MerchandiseCreate from '../merchandises/merchandise.create.svelte'
    import MerchandiseUpdate from '../merchandises/merchandise.update.svelte'

</script>

<Merchandises />

<Modal id="MerchandiseRead" title="Información" >
    <MerchandiseRead on:deleted={ MerchandiseStore.modalClose } />
</Modal>

<Modal id="MerchandiseCreate" title="Registrar mercancia" >
    <MerchandiseCreate on:created={ MerchandiseStore.modalClose } on:canceled={ MerchandiseStore.modalClose } />
</Modal>

<Modal id="MerchandiseUpdate" title="Actualizar mercancia" >
    <MerchandiseUpdate on:updated={ MerchandiseStore.modalClose } on:canceled={ MerchandiseStore.modalClose } />
</Modal>
